import { WorkDayJobPosting } from '@/page-templates/JobDetailsPage/interfaces';

const transformWorkdayJob = (job: { path: string } & WorkDayJobPosting) => {
  return {
    title: job.title,
    id: job.id,
    description: job.jobDescription,
    categories: job.categories?.map((category) => category.descriptor),
    timeType: job.timeType?.descriptor,
    company: job.company?.descriptor,
    location: job.primaryLocation?.descriptor,
    path: job.path,
  };
};

export default transformWorkdayJob;
